import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const InputWrapper = styled(Typography)`
  flex: 1;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: .5rem;
  align-items: center;

  & > input {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    letter-spacing: inherit;
    min-width: 0;
    ${({ inputSize }) => inputSize && css`width: ${inputSize}ch;`}
  }
`;

InputWrapper.defaultProps = {
  inputSize: undefined,
};

InputWrapper.propTypes = {
  inputSize: PropTypes.number,
};

InputWrapper.displayName = 'InputWrapper';
